import { render, staticRenderFns } from "./scene5Pc.vue?vue&type=template&id=9c51fe0c&scoped=true&"
import script from "./scene5Pc.vue?vue&type=script&lang=js&"
export * from "./scene5Pc.vue?vue&type=script&lang=js&"
import style0 from "./scene5Pc.vue?vue&type=style&index=0&id=9c51fe0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c51fe0c",
  null
  
)

export default component.exports